export class SimNaoOptions {

    public static get values() {
        return [
            { id: true, text: "Sim" },
            { id: false, text: "Não" }
        ];
    }
}
